import * as Updates from 'expo-updates';
import React, {useEffect} from 'react';
import {
  Alert,
  Linking,
  Platform,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';

import LineIcon from 'react-native-vector-icons/SimpleLineIcons';

import UserProfileIcon from 'src/Modules/UserProfileIcon';

import {setCurrentGroupId} from 'src/Redux/reducers/user_info.reducer';
import isIphoneX from 'src/Utils/IphoneXHelper';

import {logOutUser} from 'src/Redux/reducers/user_info.reducer';
import openURLInBrowser from '../Utils/openURLInBrowser';

import dJSON from 'dirty-json';
import VersionNumber from 'react-native-version-number';

///////////////////////
///////////   utils

import {useDrawerStatus} from '@react-navigation/drawer';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {ScrollView} from 'react-native-gesture-handler';
import {setDataAtPath} from 'src/Utils/fireUtils';
import {useUserId} from '../Hooks/reduxHooks';
import {
  setIsDrawerOpen,
  setPreviousVisit,
} from '../Redux/reducers/current_screen.reducer';
import {setEventId, updateEventInfo} from '../Redux/reducers/event.reducer';
import {saveUserInfo} from '../Redux/reducers/user_info.reducer';
import {getDataAtPath} from '../Utils/fireUtils';
import {getReduxState} from '../Utils/helpers';
import {mmkvStorage} from '../Utils/mmkvStorage';

import {api_delete_user_or_group} from '../Utils/apiCalls';

import Sentry from 'src/Modules/Native/sentry';

const isX = isIphoneX();

// efficiency wrapper
// ensure that this expensive component does not update every single time!
const DrawerMenuWrapper = (props = {}) => {
  const isDrawerOpen = useDrawerStatus() === 'open';
  const dispatch = useDispatch();

  // used to track if drawer is open
  useEffect(() => {
    dispatch(setIsDrawerOpen(isDrawerOpen));
  }, [isDrawerOpen]);

  // console.log({isDrawerOpen});
  // if (!isDrawerOpen) {
  //   return <View></View>;
  // }
  return <DrawerMenu {...props} />;
};

const openFirebaseLink = (link, isLRAdmin) => {
  if (__DEV__ && Platform.OS != 'web') {
    console.log('opening in browser');
    openURLInBrowser(link);
  } else if (isLRAdmin) {
    console.log('opening url');
    Linking?.openURL(link);
  } else {
    console.log('no match');
  }
};

const DrawerMenu = () => {
  console.log('DrawerMenu rerender');

  const dispatch = useDispatch();
  const eventId = useSelector((state) => state.event?.eventId);
  const userId = useUserId();

  const loggedIn = useSelector((state) => state.user?.loggedIn);
  const badgesEarnedCount = useSelector(
    (state) => state.user?.info?.badgesEarnedCount,
  );
  const utm_source = useSelector((state) => state.user?.utm_source);
  const customAdView = useSelector((state) => state.user?.customAdView);
  const shareLink = useSelector((state) => state.user?.shareLink);

  const currentHuntInfo = useSelector(
    (state) => state.user?.info?.currentHuntInfo,
  );

  const currentLocationId = useSelector(
    (state) => state.game_v2?.currentLocationId,
  );
  const currentChallengeId = useSelector(
    (state) => state.game_v2?.currentChallengeId,
  );

  const playTestState = useSelector((state) => state.app_info?.playTestState);

  const isLRAdmin = useSelector((state) =>
    state.user?.info?.email?.includes?.('letsroam'),
  );

  const catchLoginPress = (route, params = {}) => {
    if (loggedIn) {
      navigationRef.navigate(route, params);
    } else {
      navigationRef.navigate('LoginModal', {
        navigateOnCloseRoute: route,
        message: 'You must log in to use this feature',
      });
    }
  };

  const handleGoHome = () => {
    dispatch(setCurrentGroupId(null));
    const currentScreen = getReduxState(['current_screen', 'currentScreen']);
    if (currentScreen == 'LandingPage') {
      navigationRef.goBack();
    }
    navigationRef.navigate('LandingPageMain', null, 'DrawerMenu handleGoHome');
    navigationRef.navigate('LandingPage');
  };

  // note this component has a should component update
  // make sure to add relevant variables

  //console.log('drawer menu is doing a render')

  return (
    <View
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        bottom: 0,
      }}>
      <View style={{flex: 1}}>
        <View
          style={{
            height: 130,
            paddingTop: isX ? 40 : 20,
            width: '100%',
            backgroundColor: global?.color?.orange,
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <UserProfileIcon
            showName
            showProfile
            textColor={global?.color?.white}
            handleSignInPress={() => {
              if (loggedIn) {
                catchLoginPress('FoxShop', {
                  view: 'profile',
                });
              } else {
                navigationRef.navigate('LoginModal');
              }
            }}
          />
        </View>
        <ScrollView>
          <View style={{flex: 1, marginTop: 10, position: 'relative'}}>
            <NavButton
              isLRAdmin={isLRAdmin}
              screenTitle={'Home'}
              icon={'home'}
              navigationAction={handleGoHome}
            />

            {playTestState == false && loggedIn && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={`View Badges (${badgesEarnedCount || 0})`}
                icon={'badge'}
                navigationAction={() => {
                  navigationRef.navigate('BadgesInfoModal');
                }}
              />
            )}

            {playTestState == false && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'FAQs'}
                icon={'question'}
                navigationAction={() => navigationRef.navigate('FAQ')}
              />
            )}

            {playTestState == false && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Redeem Code'}
                icon={'key'}
                navigationAction={() => {
                  catchLoginPress('JoinLanding', {
                    view: 'JoinLanding',
                  });
                }}
              />
            )}

            {playTestState == false && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Get Tickets'}
                icon={'handbag'}
                showBackpack
                navigationAction={() => {
                  if (!loggedIn) {
                    return navigationRef.navigate('LoginModal', {
                      navigateOnCloseRoute: 'PurchaseModal',
                      message: 'You must log in to get tickets',
                    });
                  }
                  navigationRef.navigate('PurchaseModal');
                }}
              />
            )}
            {playTestState == false && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Contact Support'}
                icon={'support'}
                navigationAction={() => {
                  navigationRef.navigate('SupportModal');
                }}
              />
            )}

            {shareLink != null && playTestState && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Refer A Friend'}
                icon={'user-following'}
                navigationAction={() => {
                  navigationRef.navigate('ReferralModal');
                }}
              />
            )}

            {!loggedIn && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Sign In'}
                icon={'user-follow'}
                navigationAction={() => navigationRef.navigate('LoginModal')}
              />
            )}

            {!!loggedIn && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Sign Out'}
                icon={'user-unfollow'}
                navigationAction={() => {
                  navigationRef.navigate('LandingPage');
                  setTimeout(() => {
                    setCurrentGroupId(null);
                    dispatch(logOutUser());
                  }, 1000);
                }}
              />
            )}
            {!!(isLRAdmin || __DEV__) && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={playTestState ? 'Exit Playtest' : 'Enter Playtest'}
                icon={'arrow-right'}
                navigationAction={async () => {
                  let versionNumber =
                    VersionNumber.appVersion || VersionNumber.versionCode;
                  versionNumber = versionNumber?.replace(/\./gi, '_');

                  const featurePath = `versionInfo/${Platform.OS}/${versionNumber}/playTest`;
                  console.log({featurePath});
                  await setDataAtPath(featurePath, !playTestState ? 1 : 0);
                  navigationRef.navigate(
                    'LandingPageMain',
                    null,
                    'Drawermenu play',
                  );
                }}
              />
            )}
            {/* @ts-ignore */}
            {!!(isLRAdmin || __DEV__) && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Force Navigation'}
                icon={'arrow-right'}
                navigationAction={() => {
                  navigationRef.navigate('ConfirmModal', {
                    titleText: `Where do you want to navigate?`,
                    titleBodyText: `This will reset your app to base state, and log you out of your user account. Common routes are:
                    \nMain: \nLandingPageMain, LoginPage,LoginAdditionalInfoFullScreenPage,PassportStack,PreGameStack,MainGameStack \n
                    \nGame: \nHuntLoading, HuntIntro, NavigationChallenge, NavigationScore, LocationOutro, ClassicChallenges, ClassicIntro, LocationComplete, LocationChallenge, LocationChallengeScore, HuntOutro, TeamPhoto, HuntFinished, HuntFinishedPlayer, HuntPhotos, PlayerTreasureChallenges, PlayerDashboard_v2
                    \nFormat:\nRoute|||{JSON}
                      `,
                    showPrompt: true,
                    confirmText: 'Navigate',
                    cancelText: 'Cancel',
                    handleConfirm: (text, handleDone) => {
                      if (text) {
                        const [route, jsonString = '{}'] = text.split('||');
                        console.log({route, jsonString});
                        handleDone();
                        navigationRef.navigate(route, dJSON.parse(jsonString));
                        // NavigationChallenge||{locationId: l_131}
                      }
                    },
                  });
                }}
              />
            )}

            {(isLRAdmin || __DEV__) && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Debug Listeners'}
                icon={'info'}
                navigationAction={async () => {
                  const firebaseListeners = getReduxState([
                    'current_screen',
                    'firebaseListeners',
                  ]);
                  console.log({firebaseListeners});
                  global.devAlert(Object.values(firebaseListeners));
                }}
              />
            )}
            {(isLRAdmin || __DEV__) && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Clear Storage'}
                icon={'size-actual'}
                navigationAction={() => {
                  navigationRef.navigate('ConfirmModal', {
                    titleText: `Are you Sure You Want To Clear Your Storage?`,
                    titleBodyText:
                      'This will reset your app to base state, and log you out of your user account.',
                    confirmText: 'Delete Device Storage',
                    cancelText: 'Cancel',
                    handleConfirm: () => {
                      mmkvStorage.clearAll();
                      Alert.alert('Device Storage Cleared');
                      navigationRef.goBack(null);
                      navigationRef.goBack(null);
                      navigationRef.goBack(null);
                      navigationRef.goBack(null);
                      navigationRef.navigate('AppIntroSwiper');
                      setTimeout(() => {
                        dispatch(setCurrentGroupId(null));
                        dispatch(setPreviousVisit(0));
                        dispatch(logOutUser());
                        mmkvStorage.clearAll();
                        dispatch({type: 'HARD_RESET'});
                      }, 1000);
                      Updates.reloadAsync();
                    },
                  });
                }}
              />
            )}

            {userId && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Delete User'}
                icon={'size-actual'}
                navigationAction={() => {
                  if (userId?.length > 2) {
                    navigationRef.navigate('ConfirmModal', {
                      titleText: `Are you Sure You Want To Delete Your User?`,
                      titleBodyText:
                        'This will delete your user, progress, and all your info from our servers. This can not be undone.',
                      confirmText: 'DELETE ALL USER INFO',
                      cancelText: 'Cancel',
                      handleConfirm: async () => {
                        // let mikes = await getDataAtOrderBy({
                        //   path: '/users/',
                        //   orderBy: 'contactEmail',
                        //   equalTo: 'mike@letsroam.com',
                        //   multiple: true,
                        // });
                        // console.log({mikes});

                        await api_delete_user_or_group({
                          id: userId,
                          type: 'user',
                        });
                        navigationRef.navigate('LandingPage');
                        setTimeout(() => {
                          logOutUser();
                          navigationRef.goBack(null);

                          navigationRef.navigate(
                            'LandingPageMain',
                            'DrawerMenu delete user',
                          );
                          setCurrentGroupId(null);
                          dispatch(logOutUser());
                          mmkvStorage.clearAll();
                          dispatch({type: 'HARD_RESET'});

                          Updates.reloadAsync();
                        }, 1000);
                      },
                    });
                  }
                }}
              />
            )}

            {(isLRAdmin || __DEV__) && currentHuntInfo?.groupId && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Delete Group'}
                icon={'size-actual'}
                navigationAction={async () => {
                  if (userId?.length > 2) {
                    await api_delete_user_or_group({
                      id: currentHuntInfo?.groupId,
                      type: 'group',
                    });
                    setDataAtPath(`users/${userId}/currentHuntInfo`, null);
                    navigationRef.navigate('LandingPage');
                  }
                }}
              />
            )}

            {(isLRAdmin || __DEV__) && currentHuntInfo?.groupId && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Finish Hunt'}
                icon={'size-actual'}
                navigationAction={() => {
                  if (userId?.length > 2) {
                    setDataAtPath(
                      `scavengerhunt/groups/${
                        currentHuntInfo?.groupId || 'error'
                      }/huntFinished`,
                      true,
                    );
                    navigationRef.navigate('LandingPage');
                  }
                }}
              />
            )}

            {(isLRAdmin || __DEV__) && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Simulate Error'}
                icon={'size-actual'}
                navigationAction={() => {
                  navigationRef.navigate('ConfirmModal', {
                    titleText: `What type of error do you want?`,
                    confirmText: 'JS Error',
                    cancelText: 'Native Error',
                    thirdOption: 'Cancel',
                    handleConfirm: async (handleDone) => {
                      const data = null;
                      // simulated error
                      // dont freak lol
                      data.length;
                      handleDone();
                    },
                    handleCancel: (handleDone) => {
                      Sentry.nativeCrash();
                      handleDone();
                    },
                  });
                }}
              />
            )}

            {(isLRAdmin || __DEV__) && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Sign In As Another User'}
                icon={'user-follow'}
                navigationAction={() => {
                  navigationRef.navigate('ConfirmModal', {
                    titleText: `What user id?`,
                    titleBodyText: `Pick a user to sign in as. Dev feature.`,
                    showPrompt: true,
                    confirmText: 'Navigate',
                    cancelText: 'Cancel',
                    handleConfirm: async (text, handleDone) => {
                      if (text) {
                        const userDataPath = `users/${text || 'error'}`;
                        console.log({userDataPath});
                        const userInfo = await getDataAtPath(userDataPath);
                        if (!userInfo) {
                          return Alert.alert(
                            'Welcome! To access this feature, please log in to your account.',
                          );
                        }
                        mmkvStorage.set('userId', userInfo?.userId);
                        mmkvStorage.set('userInfo', JSON.stringify(userInfo));
                        dispatch(saveUserInfo(userInfo));
                        Alert.alert('You are signed in as that user');
                        handleDone();
                      }
                    },
                  });
                }}
              />
            )}

            {!!eventId && (
              <NavButton
                screenTitle={'Leave Event'}
                icon={'size-actual'}
                navigationAction={() => {
                  console.log('setEventId DrawerMenu');
                  dispatch(setEventId(null));
                  dispatch(updateEventInfo(null));
                  navigationRef.navigate('LandingPage');
                }}
              />
            )}

            {(isLRAdmin || __DEV__) && (utm_source || customAdView) && (
              <NavButton
                isLRAdmin={isLRAdmin}
                screenTitle={'Show Ad Info'}
                icon={'size-actual'}
                navigationAction={() => {
                  Alert.alert(
                    `The UTM Source is ${utm_source}
                     and the custom ad view is ${customAdView}`,
                  );
                }}
              />
            )}
          </View>

          <View style={{marginBottom: 20}}>
            {playTestState == false && loggedIn && (
              <TouchableOpacity
                style={{
                  marginLeft: 10,
                }}
                onPress={() => {
                  openFirebaseLink(
                    `https://console.firebase.google.com/u/0/project/barhuntv2/database/barhuntv2/data/users/${
                      userId || ''
                    }`,
                    isLRAdmin,
                  );
                }}>
                <Text style={{fontSize: 10}}>{`User Id: ${userId || ''}`}</Text>
              </TouchableOpacity>
            )}
            {playTestState == false && currentHuntInfo?.groupId && (
              <TouchableOpacity
                style={{
                  marginLeft: 10,
                  marginTop: 2,
                }}
                onPress={() => {
                  openFirebaseLink(
                    `https://console.firebase.google.com/u/0/project/barhuntv2/database/barhuntv2/data/scavengerhunt/groups/${
                      currentHuntInfo?.groupId || ''
                    }`,
                    isLRAdmin,
                  );
                }}>
                <Text style={{fontSize: 10}}>
                  {`Group Id: ${currentHuntInfo?.groupId || ''}`}
                </Text>
              </TouchableOpacity>
            )}
            {playTestState == false && loggedIn && currentHuntInfo?.groupId && (
              <TouchableOpacity
                style={{
                  marginLeft: 10,
                  marginTop: 2,
                }}
                onPress={() => {
                  openFirebaseLink(
                    `https://console.firebase.google.com/u/0/project/barhuntv2/database/barhuntv2/data/scavengerhunt/completions/${
                      currentHuntInfo?.groupId || ''
                    }`,
                    isLRAdmin,
                  );
                }}>
                <Text style={{fontSize: 10}}>
                  {`Hunt Id: ${currentHuntInfo?.huntId || 'No Hunt Id'}`}
                </Text>
              </TouchableOpacity>
            )}
            {!!currentLocationId && !!(__DEV__ || isLRAdmin) && (
              <TouchableOpacity
                style={{
                  marginLeft: 10,
                  marginTop: 2,
                }}
                onPress={() => {
                  openFirebaseLink(
                    `https://console.firebase.google.com/u/0/project/barhuntv2/database/barhuntv2/data/scavengerhunt/completions/${
                      currentHuntInfo?.groupId || ''
                    }/location_v2/locations/${currentLocationId}`,
                    isLRAdmin,
                  );
                }}>
                <Text style={{fontSize: 10}}>
                  {`Location Id: ${currentLocationId}`}
                </Text>
              </TouchableOpacity>
            )}
            {!!currentChallengeId && !!(__DEV__ || isLRAdmin) && (
              <TouchableOpacity
                style={{
                  marginLeft: 10,
                  marginTop: 2,
                }}
                onPress={() => {
                  openFirebaseLink(
                    `https://console.firebase.google.com/u/0/project/barhuntv2/database/barhuntv2/data/scavengerhunt/completions/${
                      currentHuntInfo?.groupId || ''
                    }/location_v2/allChallenges/${currentChallengeId}`,
                    isLRAdmin,
                  );
                }}>
                <Text style={{fontSize: 10}}>
                  {`Challenge Id: ${currentChallengeId}`}
                </Text>
              </TouchableOpacity>
            )}
            {!!(__DEV__ || isLRAdmin) && (
              <TouchableOpacity
                style={{
                  marginLeft: 10,
                  marginTop: 2,
                  marginBottom: 0,
                }}
                onPress={() => {
                  openFirebaseLink(
                    `https://hventures2.letsroam.com/admin/corporate/lead_details?uuid=${eventId}`,
                    isLRAdmin,
                  );
                }}>
                <Text style={{fontSize: 10}}>
                  {`Event Info: ${eventId || 'No Event Id'}`}
                </Text>
              </TouchableOpacity>
            )}
            {playTestState == false && loggedIn && eventId && (
              <TouchableOpacity
                style={{
                  marginLeft: 10,
                  marginTop: 2,
                  marginBottom: -10,
                }}
                onPress={() => {
                  openFirebaseLink(
                    `https://console.firebase.google.com/u/0/project/barhuntv2/database/barhuntv2/data/customEvents/${eventId}`,
                  );
                }}>
                <Text style={{fontSize: 10}}>
                  {`Event Id: ${eventId || 'No Event Id'}`}
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

const NavButton = ({navigationAction, screenTitle, icon}) => {
  return (
    <TouchableOpacity
      onPress={navigationAction}
      style={{
        width: '100%',
        height: 23,
        marginVertical: 5,
      }}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          textAlign: 'left',
        }}>
        <Text style={{textAlign: 'left', marginHorizontal: 10}}>
          <LineIcon size={18} name={icon} color={global?.color?.gray3} />
        </Text>
        <Text
          style={{
            color: global?.color?.gray3,
            fontSize: 16,
            fontFamily: global?.font.circular,
            textAlign: 'left',
            fontWeight: '700',
          }}>
          {screenTitle}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

export default DrawerMenuWrapper;
